import { IApi } from "../shared/Interface/IApi";

/**
 * if want to call API, just do (example):
 *
 * const url = `${ApiService.Identity}/YourEndPointHere`;
 */
const BaseUrl = "https://api.apps.binus.ac.id/gahelpdesk";

export const ApiService: IApi = {
  blob: "https://stresources.blob.core.windows.net/profilepicture",
  organization: "https://apim-bm7-dev.azure-api.net/func-organization-dev",
  profile:
    "https://apim-mydashboardbinusmaya-dev.azure-api.net/func-mydashboardbinusmaya-profile-dev",
  dashboard:
    "https://apim-mydashboardbinusmaya-dev.azure-api.net/func-mydashboardbinusmaya-dashboard-dev",
  getToken: `${BaseUrl}/Auth/token`,
  apiHc: {
    getProfile: `${BaseUrl}/api-hc/get-profile`,
  },
  identity: {
    getProfile: `${BaseUrl}/MasterUser/getProfile`,
  },
  users: {
    getUsers: `${BaseUrl}/MasterUser/getUsers`,
    updateUser: `${BaseUrl}/MasterUser/updateUser`,
  },
  roles: {
    getRoles: `${BaseUrl}/MasterRole/getRoles`,
    updateRole: `${BaseUrl}/MasterRole/updateRole`,
    createRole: `${BaseUrl}/MasterRole/createRole`,
    deleteRole: `${BaseUrl}/MasterRole/deleteRole`,
  },
  location: {
    createLocation: `${BaseUrl}/MasterLocation/createLocation`,
    deleteLocation: `${BaseUrl}/MasterLocation/deleteLocation`,
    editLocation: `${BaseUrl}/MasterLocation/deleteLocation`,
    getLocation: `${BaseUrl}/MasterLocation/getLocation`,
    getLocationDetail: `${BaseUrl}/MasterLocation/getLocation`,
    updateLocation: `${BaseUrl}/MasterLocation/updateLocation`,
  },
  form: {
    createForm: `${BaseUrl}/MasterForm/createForm`,
    deleteForm: `${BaseUrl}/MasterForm/deleteForm`,
    getForm: `${BaseUrl}/MasterForm/getForm`,
    getFormDetail: `${BaseUrl}/MasterForm/getForm`,
    updateForm: `${BaseUrl}/MasterForm/updateForm`,
  },
  preventiveME: {
    createPreventiveME: `${BaseUrl}/MasterPreventiveME/createPreventiveME`,
    deletePreventiveME: `${BaseUrl}/MasterPreventiveME/deletePreventiveME`,
    getPreventiveME: `${BaseUrl}/MasterPreventiveME/getPreventiveME`,
    getPreventiveMEDetail: `${BaseUrl}/MasterPreventiveME/getPreventiveMEDetail`,
    updatePreventiveME: `${BaseUrl}/MasterPreventiveME/updatePreventiveME`,
  },
};

export const subscriptionKeyLMSBM7 = "3036affa50694b0fb6ba6552772007c2";
export const subscriptionKeyMyDashboardBinusMaya =
  "c01143afab0f4501ac8c34f6586d6a94";
export const gaTrackingID = ""; /** dev */
export const TestMode = true;
export const REDPER = "";
export const ENVIRONMENT = "development";
